import { Injectable } from '@angular/core';
const forge = require('node-forge');
@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  readonly moduleSecret = "f041fb961650af8ujik2a7cb35cdc26d66804b80dd298tdab7b65ff48c3c56de";
  readonly moduleid = "5D824A3E-F36B-1410-8351-00CE2C21D66E";
  readonly publicKeys = `-----BEGIN PUBLIC KEY-----
  MIICITANBgkqhkiG9w0BAQEFAAOCAg4AMIICCQKCAgBzoocwoczoB6q9LfI8vYcf
  UHmgBJHwLjkmXSGjysPRC6KHFJeMD8Cp1EUVjf7U8mJVUuwfbOcBaK3y5nWP6mnt
  jAzp3MdKpd8ujd+REH9rvDWH97+2DlCquNliYfziYR1EZHFPn6WVRSLjpjML2/K6
  Hqh3Nu9SM4GacdPQqF5lSC/UW7AkvJKMgS3rJlvKqMbDiUnfBSSv9Oqj3SeCHWVu
  4uQJlYG91VJ5GwNBM0Ytvqq5mKe9FbXrPLnvIQoP+SPWxGHbNncjVnLKEM0JzeJC
  wYDf6TB5aIIJaZYvCuNi1tnLmGZoIRUg3eFocx8JnZuxN95+PBx0iEvwyUte+Kjm
  mzsS9cr+6yBfywbqF43GR9a5XA7bu99+ZhqjwP4s5qEX+8Nzulqzv28EAKD7uqQ3
  Opb81byzpynacQF6AG2TGI5DHGY1/u4p9jt8GvjxzG1WzLvpJgzvhNDRkcKOnZb/
  7oJvfrZbY+Crb95jKlqEKni2YJljCF4eJiu9birHHrRxrvsmH+wvlm0WAyoCnVyn
  eNV1VlTph29b9/KpNxXYwN6z2NnPFLd0k/IJrrCpIf+cnXxn0bo4y4tE3OhFrTZa
  YhhdjlDvBjqBhAEyMq8t07o14GhSUw5hPfKG4QaMAdsqdJWTVjZrkNfxkA1xmpVP
  NwUum/8YjyRU0ix0s8g7IwIDAQAB
  -----END PUBLIC KEY-----`;

  readonly privateKeys = `-----BEGIN RSA PRIVATE KEY-----
MIIJKgIBAAKCAgEAukZFZhmVwTZn+oooAT75xOl5sfJoHMnyXWKmFRNf1wF+Cmf+
5vJZ1WRKPs2l+KeeVYK9AiVdsnh9OxIih5k2RqdoX4SnW0kqcxCyjUJe1NrJCUnS
U6OWEgbadZhg4O12k2ZTKQkV0i/kABzK7GkOMiR9KZV06R3xt7Pi9Y+8N4RwVgsH
9xMAMfhqAK0w8qffLgiHADfa5DKpVUC8ZnwPHmgJbQBsD7HwaqpMlrTVB9TguN5b
rq4voXzUurjXBobfYujYgYjutqsTMjKMi4zfx7CVlPVKIhLJwPAVVuGly6eTXxsh
YwJQVdzndtA80YdEqZgiRsngk1i4x6GTv40salZgOooEZ07IZBu3dVSN2P7MeXAv
d9P7dosrqK7A34cLg1265TydPWAG9D1/D9iOO+LFE0d6aMetq7THduwT4f3c2lK5
udvY+mUmyL1GJvvKvvb+KDuBAUJqRC/oyysZDEK9sYjkcks3u6weM6xRgG53zKT8
PKmkbp1kLKfI0C5NTVPepH/3BuMP9GcUVm96Wgc4q6ERoIfq+bsujpWWmDlI23BQ
uiMtlH2ELQDrJLmH4NQjX6z+bFjT+4KELRf7owBkvk6yuSwLrgk0+o43pJn1ehEc
BEdBG5dOsUFLcAT8sVwnKV9/YHQBs0lhhwFkZTBC++To6RYxoxY2Hnje518CAwEA
AQKCAgEAtqUYfxgvIpg6NAsrVq1tMorLbJQHSdMp9i84MgohOyyXbZSy97hCJV6E
/jeeucWBFs9ujKAe01QZVsZdXR/5fCXBzYbAol2HZfPFX4Tof0VXQehEdwY7q8lU
g2G5/FJapgT7HY1u+/1BTmrs/gm0ha4Jm7CURc+6pymXLLiXEMinbXa7hKP42QZ+
ydMH36aCyxxJYwlhc8fJCXLESKj0GhhgxaRYULtkxPHezxbYmyk8f4hn1UuuIGXK
IJwFGr08ZDtzru+ZQTtVQy8VZ+/lrGOVB83LtsU9VhUSl3IBo0LY2bQ8dFxccRR9
UJ62Q6yiwrgNQ+PGdDPWWsgvmu7N0Hcr0pduEoGu+Jwf5PumLDmVRIVJByIB44Ai
TJ8D47holwRdrfEMl32mkj9YZ5n08DXSKjLDeJRAXoYfcpfsm2YlOkAThkAV34vE
Qs1EqaXAEzVTxhFSrxDNz7rUsEbBWvO7Bg2LxPIyAs1w4XnpRjj55sBvE3hM2ctq
8TOGXDysJN4BnwkKEfTsL0rerK9PdfG+0XR8yVc8JTuK58FyheVc2Ex7PrXavvfZ
sX001+RnEzMA7dMSlT4zJIxyqjYV49m2ogxSxDUKb/mfBUjvhsngapSI4DZpFxmc
fhnCupZkT4D9Ze2zYwwZciq7UDqDwNnoRqaN1m5KS+qh78Sm9eECggEBAPZklmbx
NQyCn1kmW4zcxgOTon1Z6mG4MOgopzwux0XzavfO2OydkmW7j9ISIDWyM2aDT3E8
syKXZOKzX8q8kXW6Uu7JpssHyua2Sj4v8G074w92faGg6C1AE24KuH+MdMipMefa
JUG2rFQ/Y63CUB+c9mH4/aTm+BKI8I2EsCIC1ZXyHSXM3uob3vm4ws6xCP7PKuUZ
z0v8x763Y0JLwJjnBcjlT1GZvSC6fs9bNc9KhtAlVBw4fLK8EYAKwzUZivBDfocc
BFxsBRSEmcC11Sg2ufckUZPtFnZOkuIS0uOS0KVyE+o4J+x6h1/m5fWYG8wM+6gX
WEpQyxdoH9lWAm0CggEBAMGJmfUVSsSuS3bjYtAsMMPrtF/z5D/jKRKdeqVatXRX
N5h3R/7AKei5wqMf6MI3y7KByvTMWUTuC4P84sDnb5ANXYHfgir7equBT8CRIEkj
Hesq0GUolgBRZ67/mrIbptWKZX4y0HqyS8GJ0W7wlaGjVeTYC8oEckE3cx4DPNzh
yGnfF1UoFqu4/rD6qQFaf2plH7ULD1FbgmF+mQ3eiG2+stytVCeCtSOcBUSs3gja
/B3i+9p0yuIOZ941cGqu3s8m5CPd1tVly4ToODtUZVuQ/5mD/Td1TYMVaMfZSaQm
n5jXUSvPuCQbHxVb3Lt36XhxuVy4FMmk+2psjo5ckXsCggEBAPBld7D8iiuojlxm
5k/rX29B7fmrbtjk4yK/91rqsRZ4xtb9A/zoSFvlwg7ODIsXULsmRq5O8OBBIfdl
14JwtONOZXgBWzEga0DqfklqcIPDOGhvzWeTHLR5nftxjk0z9wWIvt5dopgY6M5S
AqkXuyD8/g7c5myrxUIgRcNtwIOOjGF+Fh45Ywy7ILQ5JiiP5hzmeA2LPwv+l8xm
FPwr+L+2N5io0tjkzPhPvUYG0dtr9VjD8uqN2mxwvgpVddwrDboZwCuGlGKwKcy5
C2JQhqZzrsGIt+dCHPZU906H2yaaqeOiB/gvzhQWAFr7Z0ZVoFlYGXkJPeVUKrKt
rtVX64kCggEBAIgFGXsyV7YbeVY5QX1lUXCg+8hkNQrhsEAxBb2pHtaBZcV2L9dP
XyT9SVo0VvYJGNSAfA/IfwT++IDu/r7s6W+otQtN9sIWtIRNAawpUzOTxrc9A/HU
sHfQvrozUpnS7VIvTl1/gR56qNuA7Py3gbJ0hS2s2bxFm7dSLUnupJvo413lORTU
c/qErhvcT2NwIxS3ta0b9MwNMHks7Ize1aur1zFZcEfEiWJZiSpXBEXdAkxO9wr2
ApEV5tI5ZKTV+ipE/xpmE1Mvk/X472xjSEkugzV1mkWb37o9FcM/Z45CxvA4hAfy
mUxm81WjlmL7R88qvkf36EQ/+6M0YIyVankCggEAWI2PshazBI5L9nlRlCldmW5m
eQ0TS6O5spvLUF1Lcq540Q1Eh159QBg3P2uMb96SVkNf29tJsKFo9x5NIE0NU89a
Mnrbzba/+1wy6fwmgI4Zyu4K3YeRwCB16N0pQfXcs8FZXPrRgYCWP7+kV+WQ93kB
w0LCqMNrawdNaZOC5ijwHAeg9ca6FlwmHeM+8au+dnDW0bYAXBaMnFxSgSy08GnN
Gxe2ztfIwoOBmbiAEq0lBdLzWKyuzO79/+R1Io7ls2iktwXB01XWWLQIyzL+k/JL
IeP0ALoIxDV2vGN6sTs94iwpNWD0lFo8za2I3NoECN5uMw3c0DKXBWGElO4idA==
-----END RSA PRIVATE KEY-----`;

  constructor() { }


  encryptWithPublicKey(valueToEncrypt: string): string {
    const rsa = forge.pki.publicKeyFromPem(this.publicKeys);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }


  /**
  * Decrypt data with a private key using RSA-OAEP
  */
  decryptWithPrivateKey(valueToDecrypt: string): string {
    // Decode the Base64 encrypted data back into binary format
    const encryptedBinary = forge.util.decode64(valueToDecrypt);

    // Convert PEM private key to a Forge private key object
    const rsaPrivateKey = forge.pki.privateKeyFromPem(this.privateKeys);

    // Decrypt the binary data using RSA-OAEP
    const decrypted = rsaPrivateKey.decrypt(encryptedBinary, 'RSAES-PKCS1-V1_5', {
      md: forge.md.sha256.create(), // Ensure the same hash algorithm is used
      mgf1: {
        md: forge.md.sha256.create(), // Ensure the same MGF1 hash is used
      },
    });

    // Return the decrypted string
    return decrypted;
  }

  public getAuthToken() {
    let data: any = sessionStorage.getItem('currentUser');
    return JSON.parse(data).authToken;
  }

  public getMenuPermissions(formSubTitle?: string): { canAdd: boolean, canEdit: boolean, canView: boolean, isActive: boolean } {
    let permissions = { canAdd: false, canEdit: false, canView: false, isActive: false };
    let roleMenusStr = sessionStorage.getItem('roleMenus');

    if (roleMenusStr) {
      try {
        let roleMenus = JSON.parse(roleMenusStr);
        let allMenus: any[] = [];

        const flattenMenus = (menus: any) => {
          if (!menus) return;
          if (Array.isArray(menus)) {
            menus.forEach(m => {
              allMenus.push(m);
              if (m.roleMenuList) {
                flattenMenus(m.roleMenuList);
              }
            });
          } else if (typeof menus === 'object') {
            if (menus.roleMenuList) {
              flattenMenus(menus.roleMenuList);
            } else if (menus.requestData && menus.requestData.roleMenuList) {
              flattenMenus(menus.requestData.roleMenuList);
            } else {
              allMenus.push(menus);
            }
          }
        };
        flattenMenus(roleMenus);

        let currentMenu = allMenus.find(m => {
          if (m.menuName && formSubTitle) {
            let mName = m.menuName.toLowerCase().replace(/s$/, '');
            let subTitle = formSubTitle.toLowerCase().replace(/s$/, '');
            if (mName === subTitle) return true;
          }
          return false;
        });

        if (!currentMenu) {
          currentMenu = allMenus.find(m => {
            if (!m.menuParameter) return false;
            let param = m.menuParameter.split('/').pop() || '';
            let baseParam = param.toLowerCase().replace('listview', '').replace('list', '');
            return window.location.href.toLowerCase().includes(baseParam);
          });
        }
        console.log(currentMenu, "currentMenu>>>>")

        if (currentMenu) {
          permissions.canAdd = currentMenu.canAdd;
          permissions.canEdit = currentMenu.canEdit;
          permissions.canView = currentMenu.canView;
          permissions.isActive = currentMenu.isActive;
        }
      } catch (e) {
        console.error('Error parsing roleMenus for permissions', e);
      }
    }

    return permissions;
  }
}
